<img
  alt="design-tokens.io"
  height="208"
  [ngSrc]="logoPath()"
  priority="true"
  width="1152"
  style="height: 28px; width: auto"
/>
